export default "__VITE_ASSET__wYHRPbk$__"